package com.hyperether.goodjob.scenes.register

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.ClickableText
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.clearInputCmp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.navigation.Pricing
import com.hyperether.goodjob.navigation.Register
import com.hyperether.goodjob.navigation.Workspace
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.access_the_platform
import com.hyperether.goodjob.resources.already_have_an_account
import com.hyperether.goodjob.resources.app_logo
import com.hyperether.goodjob.resources.confirm_password_reset
import com.hyperether.goodjob.resources.confirm_registration
import com.hyperether.goodjob.resources.contact_ic
import com.hyperether.goodjob.resources.continue_with_apple
import com.hyperether.goodjob.resources.continue_with_google
import com.hyperether.goodjob.resources.continue_with_microsoft
import com.hyperether.goodjob.resources.create_one
import com.hyperether.goodjob.resources.email_address
import com.hyperether.goodjob.resources.email_format_not_valid
import com.hyperether.goodjob.resources.email_ic
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.forgot_password
import com.hyperether.goodjob.resources.hello
import com.hyperether.goodjob.resources.join_good_job
import com.hyperether.goodjob.resources.join_us
import com.hyperether.goodjob.resources.login_to_access
import com.hyperether.goodjob.resources.need_an_account
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.pass_ic
import com.hyperether.goodjob.resources.password
import com.hyperether.goodjob.resources.ready_for
import com.hyperether.goodjob.resources.register
import com.hyperether.goodjob.resources.register_with
import com.hyperether.goodjob.resources.repeat_password
import com.hyperether.goodjob.resources.reset_link_sent
import com.hyperether.goodjob.resources.sign_in
import com.hyperether.goodjob.resources.sign_in_good_job
import com.hyperether.goodjob.resources.sign_in_with
import com.hyperether.goodjob.resources.thank_you_for_registering
import com.hyperether.goodjob.resources.welcome_back
import com.hyperether.goodjob.resources.your_email_address
import com.hyperether.goodjob.resources.your_full_name
import com.hyperether.goodjob.resources.your_password
import com.hyperether.goodjob.scenes.auth.MicrosoftLogin
import com.hyperether.goodjob.scenes.components.ErrorDialogNested
import com.hyperether.goodjob.scenes.components.PasswordInputField
import com.hyperether.goodjob.scenes.components.PopUpDialogNested
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.pricing.PricingViewModel
import com.hyperether.goodjob.scenes.workspace.WorkspaceViewModel
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.RegisterSubTitle
import com.hyperether.goodjob.theme.SubtitleColor
import com.hyperether.goodjob.util.Constants.RESEND_CONFIRMATION_EMAIL_CODE
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import com.hyperether.auth.apple.AppleButtonContainer
import com.hyperether.auth.apple.AppleButtonMode
import com.hyperether.auth.apple.AppleSignInResult
import com.hyperether.auth.google.GoogleButtonContainer
import com.hyperether.auth.google.GoogleButtonMode
import com.hyperether.auth.google.GoogleSignInResult
import com.hyperether.auth.microsoft.MicrosoftButtonMode
import com.hyperether.auth.microsoft.MicrosoftSignInResult
import org.jetbrains.compose.resources.painterResource

@Composable
fun RegisterScreen(
    isMobileView: Boolean,
    registerViewModel: RegisterViewModel,
    workspaceViewModel: WorkspaceViewModel,
    pricingViewModel: PricingViewModel,
    navHostController: NavHostController
) {

    val isRegisterSelected = remember { mutableStateOf(false) }
    val interactionSource = remember { MutableInteractionSource() }

    val nameInput = remember { mutableStateOf("") }
    val mailInput = remember { mutableStateOf("") }
    val passwordInput = remember { mutableStateOf("") }
    val repeatPasswordInput = remember { mutableStateOf("") }
    val showSuccessDialog = remember { mutableStateOf(false) }
    val showProgressBar = remember { mutableStateOf(false) }


    if (isMobileView) {
        Column(
            modifier = Modifier.fillMaxSize()
        ) {

            Box(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Image(
                    painter = painterResource(Res.drawable.app_logo),
                    contentDescription = "app logo",
                    modifier = Modifier
                        .align(Alignment.TopCenter)
                        .padding(bottom = Dp(16f), top = Dp(30f))
                )

            }
            Column(
                modifier = Modifier
                    .padding(top = Dp(20f), start = Dp(16f), end = Dp(16f))
                    .background(Color.LightGray.copy(alpha = 0.2f))
                    .padding(Dp(8f)),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(40.toScaleDp()),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = stringResource(Res.string.register),
                        color = if (isRegisterSelected.value) BlueApp else Color.Gray,
                        fontSize = 16.toScaleSp(),
                        modifier = Modifier
                            .weight(1f)
                            .clickable(
                                interactionSource = interactionSource,
                                indication = null
                            ) {
                                isRegisterSelected.value = true
                            },
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        textAlign = TextAlign.Center
                    )

                    Text(
                        text = stringResource(Res.string.sign_in),
                        color = if (isRegisterSelected.value) Color.Gray else BlueApp,
                        fontSize = 16.toScaleSp(),
                        modifier = Modifier
                            .weight(1f)
                            .clickable(
                                interactionSource = interactionSource,
                                indication = null
                            ) {
                                isRegisterSelected.value = false
                            },
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        textAlign = TextAlign.Center
                    )
                }
            }

            Box(
                modifier = Modifier
                    .height(Dp(2f))
                    .padding(start = Dp(16f), end = Dp(16f))
                    .fillMaxWidth(0.5f)
                    .background(if (isRegisterSelected.value) BlueApp else BlueApp)
                    .align(if (isRegisterSelected.value) Alignment.Start else Alignment.End)
            )

            if (isRegisterSelected.value) {
                RegisterSignInContent(
                    title = stringResource(Res.string.join_good_job),
                    description = stringResource(Res.string.access_the_platform),
                    nameInputText = nameInput,
                    emailInputText = mailInput,
                    passwordInputText = passwordInput,
                    repeatPasswordInput = repeatPasswordInput,
                    btnText = stringResource(Res.string.register),
                    dividerText = stringResource(Res.string.register_with),
                    isRegisterSelected = isRegisterSelected.value,
                    viewModel = registerViewModel,
                    navHostController = navHostController,
                    workspaceViewModel = workspaceViewModel,
                    pricingViewModel = pricingViewModel,
                    showSuccessDialog = showSuccessDialog,
                    showProgressBar = showProgressBar
                )
            } else {
                RegisterSignInContent(
                    title = stringResource(Res.string.sign_in_good_job),
                    description = stringResource(Res.string.login_to_access),
                    nameInputText = nameInput,
                    emailInputText = mailInput,
                    passwordInputText = passwordInput,
                    repeatPasswordInput = repeatPasswordInput,
                    btnText = stringResource(Res.string.sign_in),
                    dividerText = stringResource(Res.string.sign_in_with),
                    isRegisterSelected = isRegisterSelected.value,
                    viewModel = registerViewModel,
                    navHostController = navHostController,
                    workspaceViewModel = workspaceViewModel,
                    pricingViewModel = pricingViewModel,
                    showSuccessDialog = showSuccessDialog,
                    showProgressBar = showProgressBar
                )
            }
        }
    } else {
        RegisterHolderView {
            SelectionContainer {
                RegisterSignInContentWeb(
                    title = if (isRegisterSelected.value) stringResource(Res.string.hello) else stringResource(
                        Res.string.welcome_back
                    ),
                    description = if (isRegisterSelected.value) stringResource(Res.string.join_us) else stringResource(
                        Res.string.ready_for
                    ),
                    nameInputText = nameInput,
                    emailInputText = mailInput,
                    passwordInputText = passwordInput,
                    repeatPasswordText = repeatPasswordInput,
                    btnText = if (isRegisterSelected.value) stringResource(Res.string.register) else stringResource(
                        Res.string.sign_in
                    ),
                    dividerText = if (isRegisterSelected.value) stringResource(Res.string.register_with) else stringResource(
                        Res.string.sign_in_with
                    ),
                    isRegisterSelected = isRegisterSelected,
                    viewModel = registerViewModel,
                    workspaceViewModel = workspaceViewModel,
                    pricingViewModel = pricingViewModel,
                    navHostController = navHostController,
                    showProgressBar = showProgressBar,
                    showSuccessDialog = showSuccessDialog
                )
            }
        }
    }

    if (registerViewModel.showSendResetLinkMessage.value) {
        PopUpDialogNested(
            onDismiss = {
                registerViewModel.showSendResetLinkMessage.value = false
                registerViewModel.showForgotPasswordView.value = false
            },
            title = stringResource(Res.string.reset_link_sent),
            message = stringResource(Res.string.confirm_password_reset),
            onPositiveBtnClicked = {
                registerViewModel.showSendResetLinkMessage.value = false
                registerViewModel.showForgotPasswordView.value = false
            },
            positiveBtnText = stringResource(Res.string.ok)
        )
    }

    if (registerViewModel.showPopUpError.value) {
        ErrorDialogNested(
            onDismiss = {
                registerViewModel.showPopUpError.value = false
                registerViewModel.errorInternalCode.value = null
            },
            title = stringResource(Res.string.error).uppercase(),
            message = registerViewModel.errorText.value,
            confirmationLink = registerViewModel.errorInternalCode.value != null && registerViewModel.errorInternalCode.value == RESEND_CONFIRMATION_EMAIL_CODE,
            onLinkClick = {
                registerViewModel.resendConfirmationEmail(
                    mailInput.value, onSuccess = {
                        registerViewModel.showPopUpError.value = false
                        showSuccessDialog.value = true
                    },
                    onError = {
                        registerViewModel.showPopUpError.value = false
                        registerViewModel.showPopUpError.value = true
                    })
            }
        )
    }

    if (showSuccessDialog.value) {
        PopUpDialogNested(
            onDismiss = {
                showSuccessDialog.value = false
                isRegisterSelected.value = false
            },
            title = stringResource(Res.string.confirm_registration),
            message = stringResource(Res.string.thank_you_for_registering),
            onPositiveBtnClicked = {
                showSuccessDialog.value = false
                isRegisterSelected.value = false
            },
            positiveBtnText = stringResource(Res.string.ok)
        )
    }

    if (registerViewModel.showSendResetLinkMessage.value) {
        PopUpDialogNested(
            onDismiss = {
                registerViewModel.showSendResetLinkMessage.value = false
                registerViewModel.showForgotPasswordView.value = false
            },
            title = stringResource(Res.string.reset_link_sent),
            message = stringResource(Res.string.confirm_password_reset),
            onPositiveBtnClicked = {
                registerViewModel.showSendResetLinkMessage.value = false
                registerViewModel.showForgotPasswordView.value = false
            },
            positiveBtnText = stringResource(Res.string.ok)
        )
    }
}

@Composable
fun RegisterSignInContent(
    title: String,
    description: String,
    nameInputText: MutableState<String>,
    emailInputText: MutableState<String>,
    passwordInputText: MutableState<String>,
    repeatPasswordInput: MutableState<String>,
    btnText: String,
    dividerText: String,
    isRegisterSelected: Boolean,
    viewModel: RegisterViewModel,
    workspaceViewModel: WorkspaceViewModel,
    pricingViewModel: PricingViewModel,
    navHostController: NavHostController,
    showSuccessDialog: MutableState<Boolean>,
    showProgressBar: MutableState<Boolean>
) {

    val scrollState = rememberScrollState()
    Column(
        modifier = Modifier.verticalScrollbar(scrollState)
            .padding(start = 16.toScaleDp(), end = 16.toScaleDp())
            .verticalScroll(
                scrollState
            )
            .disableMouseDragScrollOnWeb()
    ) {
        SelectionContainer {
            Text(
                text = title,
                color = Color.Black,
                fontSize = 24.toScaleSp(),
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(top = 20.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        SelectionContainer {
            Text(
                text = description,
                color = SubtitleColor,
                textAlign = TextAlign.Left,
                fontSize = 16.toScaleSp(),
                modifier = Modifier.padding(top = 6.toScaleDp(), bottom = 4.toScaleDp())
            )
        }

        if (!isRegisterSelected) {
            Spacer(modifier = Modifier.height(30.toScaleDp()))
            val emailNotValidText = stringResource(Res.string.email_format_not_valid)
            if (getPlatformChecker().isMobile()) {
                PlatformLogin(
                    emailLabel = stringResource(Res.string.email_address),
                    emailPlaceholder = stringResource(Res.string.your_email_address),
                    passwordLabel = stringResource(Res.string.password),
                    passwordPlaceholder = stringResource(Res.string.your_password),
                    forgotPasswordLabel = stringResource(Res.string.forgot_password),
                    loginButtonLabel = stringResource(Res.string.sign_in),
                    onCredentialsEntered = { email, password ->
                        if (!isValidEmail(email)) {
                            viewModel.errorText.value = emailNotValidText
                            viewModel.showPopUpError.value = true
                            return@PlatformLogin
                        }
                        showProgressBar.value = true
                        viewModel.login(
                            email = email,
                            password = password,
                            onSuccess = {
                                onSuccessfulLogin(
                                    showProgressBar,
                                    workspaceViewModel,
                                    pricingViewModel,
                                    viewModel,
                                    navHostController
                                )
                                CoroutineScope(Dispatchers.Default).launch {
                                    viewModel.updatePushToken()
                                }
                            },
                            onError = {
                                showProgressBar.value = false
                                viewModel.showPopUpError.value = true
                            })
                    },
                    onPasswordForgotten = { email ->
                        if (isValidEmail(email)) {
                            viewModel.emailInput.value = email
                        }
                        viewModel.showForgotPasswordView.value = true
                    },
                    visibility = !viewModel.showForgotPasswordView.value,
                )
            } else {
                Box(modifier = Modifier.height(320.dp)) {
                    PlatformLogin(
                        emailLabel = stringResource(Res.string.email_address),
                        emailPlaceholder = stringResource(Res.string.your_email_address),
                        passwordLabel = stringResource(Res.string.password),
                        passwordPlaceholder = stringResource(Res.string.your_password),
                        forgotPasswordLabel = stringResource(Res.string.forgot_password),
                        loginButtonLabel = stringResource(Res.string.sign_in),
                        onCredentialsEntered = { email, password ->
                            if (!isValidEmail(email)) {
                                viewModel.errorText.value = emailNotValidText
                                viewModel.showPopUpError.value = true
                                return@PlatformLogin
                            }
                            showProgressBar.value = true
                            viewModel.login(
                                email = email,
                                password = password,
                                onSuccess = {
                                    onSuccessfulLogin(
                                        showProgressBar,
                                        workspaceViewModel,
                                        pricingViewModel,
                                        viewModel,
                                        navHostController
                                    )
                                    CoroutineScope(Dispatchers.Default).launch {
                                        viewModel.updatePushToken()
                                    }
                                },
                                onError = {
                                    showProgressBar.value = false
                                    viewModel.showPopUpError.value = true
                                })
                        },
                        onPasswordForgotten = { email ->
                            if (isValidEmail(email)) {
                                viewModel.emailInput.value = email
                            }
                            viewModel.showForgotPasswordView.value = true
                        },
                        visibility = !viewModel.showForgotPasswordView.value,
                    )
                }
            }
            AuthLoginButtons(
                onRegisteredWithGoogle = { response ->
                    showProgressBar.value = true
                    viewModel.loginWithGoogle(
                        googleResult = response,
                        onSuccess = {
                            onSuccessfulLogin(
                                showProgressBar,
                                workspaceViewModel,
                                pricingViewModel,
                                viewModel,
                                navHostController
                            )
                            CoroutineScope(Dispatchers.Default).launch {
                                viewModel.updatePushToken()
                            }
                        },
                        onError = {
                            showProgressBar.value = false
                            viewModel.showPopUpError.value = true
                        })
                },
                onRegisteredWithApple = { response ->
                    showProgressBar.value = true
                    viewModel.loginWithApple(
                        appleResult = response,
                        onSuccess = {
                            onSuccessfulLogin(
                                showProgressBar,
                                workspaceViewModel,
                                pricingViewModel,
                                viewModel,
                                navHostController
                            )
                            CoroutineScope(Dispatchers.Default).launch {
                                viewModel.updatePushToken()
                            }
                        },
                        onError = {
                            showProgressBar.value = false
                            viewModel.showPopUpError.value = true
                        })
                },
                onRegisteredWithMicrosoft = { response ->
                    showProgressBar.value = true
                    viewModel.loginWithMicrosoft(
                        microsoftResult = response,
                        onSuccess = {
                            onSuccessfulLogin(
                                showProgressBar,
                                workspaceViewModel,
                                pricingViewModel,
                                viewModel,
                                navHostController
                            )
                            CoroutineScope(Dispatchers.Default).launch {
                                viewModel.updatePushToken()
                            }
                        },
                        onError = {
                            showProgressBar.value = false
                            viewModel.showPopUpError.value = true
                        })
                }
            )
        } else {
            var emailNotValidError by remember { mutableStateOf(false) }

            Spacer(modifier = Modifier.height(10.toScaleDp()))

            SignInInputField(
                text = nameInputText.value,
                onTextChanged = {
                    nameInputText.value = it
                },
                placeholder = stringResource(Res.string.your_full_name)
            )

            Spacer(modifier = Modifier.height(8.toScaleDp()))

            SignInInputField(
                text = emailInputText.value,
                onTextChanged = {
                    emailInputText.value = it.trim()
                    emailNotValidError = false
                },
                isError = emailNotValidError && !isValidEmail(emailInputText.value),
                placeholder = stringResource(Res.string.your_email_address),
                errorMessage = stringResource(Res.string.email_format_not_valid)
            )

            Spacer(modifier = Modifier.height(8.toScaleDp()))

            PasswordInputField(
                text = passwordInputText,
                placeholder = stringResource(Res.string.your_password),
                isRegister = isRegisterSelected
            )

            Spacer(modifier = Modifier.height(8.toScaleDp()))

            PasswordInputField(
                text = repeatPasswordInput,
                placeholder = stringResource(Res.string.repeat_password),
                passwordText = passwordInputText.value,
                isSecondPasswordInput = true,
                isRegister = isRegisterSelected,
                showMismatchError = repeatPasswordInput.value.isNotEmpty() && passwordInputText.value != repeatPasswordInput.value,
            )

            FilledButton(
                onClick = {
                    if (!isValidEmail(emailInputText.value)) {
                        emailNotValidError = true
                        return@FilledButton
                    }
                    showProgressBar.value = true
                    if (isRegisterSelected) {
                        viewModel.register(
                            name = nameInputText.value.trim(),
                            email = emailInputText.value,
                            password = passwordInputText.value,
                            onSuccess = {
                                showProgressBar.value = false
                                showSuccessDialog.value = true
                            },
                            onError = {
                                showProgressBar.value = false
                                viewModel.showPopUpError.value = true
                            })
                    } else {
                        viewModel.login(
                            email = emailInputText.value,
                            password = passwordInputText.value,
                            onSuccess = {
                                onSuccessfulLogin(
                                    showProgressBar,
                                    workspaceViewModel,
                                    pricingViewModel,
                                    viewModel,
                                    navHostController
                                )
                            },
                            onError = {
                                showProgressBar.value = false
                                viewModel.showPopUpError.value = true
                            })
                    }
                },
                text = btnText,
                letterSpacing = (-0.02f).toScaleSp(),
                modifier = Modifier.padding(top = 30.toScaleDp()),
                isEnabled = if (isRegisterSelected) {
                    nameInputText.value.isNotEmpty() &&
                            emailInputText.value.isNotEmpty() &&
                            passwordInputText.value.isNotEmpty() &&
                            repeatPasswordInput.value.isNotEmpty() &&
                            (passwordInputText.value == repeatPasswordInput.value) &&
                            (passwordInputText.value.length >= 8) &&
                            (repeatPasswordInput.value.length >= 8)
                } else {
                    emailInputText.value.isNotEmpty() && passwordInputText.value.isNotEmpty()
                }
            )
        }

        Row(
            modifier = Modifier.fillMaxWidth().padding(top = 25.toScaleDp()),
            verticalAlignment = Alignment.CenterVertically
        ) {
//            Box(
//                modifier = Modifier
//                    .weight(1f)
//                    .height(Dp(1f))
//                    .background(Color.Gray)
//            )
//
//            Text(
//                text = dividerText,
//                modifier = Modifier
//                    .padding(horizontal = Dp(16f))
//                    .align(Alignment.CenterVertically),
//                color = Color.Gray,
//                fontSize = Sp(16f)
//            )
//
//            Box(
//                modifier = Modifier
//                    .weight(1f)
//                    .height(Dp(1f))
//                    .background(Color.Gray)
//            )

            if (viewModel.showForgotPasswordView.value) {
                ForgotPasswordView(
                    onDismiss = {
                        viewModel.showForgotPasswordView.value = false
                        viewModel.emailInput.value = ""
                    },
                    emailInput = viewModel.emailInput,
                    onSendResetLink = {
                        viewModel.forgotPassword()

                    }
                )
            }

        }

    }
}

private fun onSuccessfulLogin(
    showProgressBar: MutableState<Boolean>,
    workspaceViewModel: WorkspaceViewModel,
    pricingViewModel: PricingViewModel,
    viewModel: RegisterViewModel,
    navHostController: NavHostController
) {
    showProgressBar.value = false
//    workspaceViewModel.init()
    CoroutineScope(Dispatchers.Default).launch {
        pricingViewModel.getAllPlans()
    }
    if (viewModel.isEmployee()
        || viewModel.isManager()
        || viewModel.isSuperAdmin()
    ) {
        //todo uncomment if you want to go directly to dashboard
//        navHostController.navigate(Screen.Dashboard.route) {
//            popUpTo(Screen.Register.route) {
//                inclusive = true
//            }
//        }
        navHostController.navigate(Workspace) {
            popUpTo(Register) {
                inclusive = true
            }
        }
    } else {
        // new user, admin or superAdmin
        if (viewModel.getUser() != null &&
            (viewModel.getUser()?.planId?.isNotEmpty() == true ||
                    viewModel.getUser()?.workspaceId?.isNotEmpty() == true)
        ) {
            navHostController.navigate(Workspace) {
                popUpTo(Register) {
                    inclusive = true
                }
            }
        } else {
            navHostController.navigate(Pricing)
        }
    }
    if (!getPlatformChecker().isMobile())
        clearInputCmp()
}

@Composable
fun RegisterSignInContentWeb(
    title: String,
    description: String,
    nameInputText: MutableState<String>,
    emailInputText: MutableState<String>,
    passwordInputText: MutableState<String>,
    repeatPasswordText: MutableState<String>,
    btnText: String,
    dividerText: String,
    isRegisterSelected: MutableState<Boolean>,
    viewModel: RegisterViewModel,
    navHostController: NavHostController,
    workspaceViewModel: WorkspaceViewModel,
    pricingViewModel: PricingViewModel,
    showSuccessDialog: MutableState<Boolean>,
    showProgressBar: MutableState<Boolean>
) {

    val focusManager = LocalFocusManager.current
    var emailNotValidError by remember { mutableStateOf(false) }
    val scrollState = rememberScrollState()

    Column(
        modifier = Modifier.wrapContentHeight()
            .verticalScrollbar(scrollState)
            .verticalScroll(scrollState)
            .disableMouseDragScrollOnWeb()
            .padding(
                bottom = 30.toScaleDp(),
                top = 32.toScaleDp(),
                start = 100.toScaleDp(),
                end = 100.toScaleDp()
            ),
        verticalArrangement = Arrangement.SpaceBetween
    ) {
        if (isRegisterSelected.value) {
            Column(
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    text = title,
                    color = Color.Black,
                    fontSize = 32.toScaleSp(),
                    lineHeight = 38.toScaleSp(),
                    fontWeight = FontWeight.W700,
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Spacer(modifier = Modifier.height(11.toScaleDp()))
                Text(
                    text = description,
                    color = RegisterSubTitle,
                    textAlign = TextAlign.Center,
                    fontSize = 16.toScaleSp(),
                    lineHeight = 20.toScaleSp(),
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Spacer(modifier = Modifier.height(41.toScaleDp()))
                RegisterInputFieldWeb(
                    text = nameInputText.value,
                    onTextChanged = {
                        nameInputText.value = it
                    },
                    placeholder = stringResource(Res.string.your_full_name),
                    drawableResource = Res.drawable.contact_ic,
                    isSpaceAllowed = true
                )

                if (viewModel.showForgotPasswordView.value) {
                    ForgotPasswordWebView(
                        onDismiss = {
                            viewModel.showForgotPasswordView.value = false
                            viewModel.emailInput.value = ""
                        },
                        emailInput = viewModel.emailInput,
                        onSendResetLink = {
                            viewModel.forgotPassword()
                        }
                    )
                } else {
                    RegisterInputFieldWeb(
                        text = emailInputText.value,
                        onTextChanged = {
                            emailInputText.value = it.trim()
                            emailNotValidError = false
                        },
                        isError = emailNotValidError && !isValidEmail(emailInputText.value),
                        placeholder = stringResource(Res.string.your_email_address),
                        drawableResource = Res.drawable.email_ic,
                        errorMessage = stringResource(Res.string.email_format_not_valid)
                    )

                    RegisterPasswordInputFieldWeb(
                        text = passwordInputText,
                        label = stringResource(Res.string.your_password),
                        drawableResource = Res.drawable.pass_ic,
                        focusManager = focusManager,
                        isRegister = isRegisterSelected.value
                    )
                    Spacer(modifier = Modifier.height(16.toScaleDp()))
                    RegisterPasswordInputFieldWeb(
                        text = repeatPasswordText,
                        label = stringResource(Res.string.repeat_password),
                        drawableResource = Res.drawable.pass_ic,
                        showMismatchError = repeatPasswordText.value.isNotEmpty() && passwordInputText.value != repeatPasswordText.value,
                        focusManager = focusManager,
                        isRegister = isRegisterSelected.value
                    )

                    Spacer(modifier = Modifier.height(24.toScaleDp()))
                    val isRegisterEnabled = isRegisterSelected.value &&
                            passwordInputText.value.isNotEmpty() &&
                            emailInputText.value.isNotEmpty() &&
                            nameInputText.value.isNotEmpty() &&
                            passwordInputText.value == repeatPasswordText.value &&
                            passwordInputText.value.length >= 8 &&
                            repeatPasswordText.value.length >= 8

                    FilledButton(
                        onClick = {
                            if (!isValidEmail(emailInputText.value)) {
                                emailNotValidError = true
                                return@FilledButton
                            }
                            showProgressBar.value = true
                            viewModel.register(
                                nameInputText.value.trim(),
                                emailInputText.value,
                                passwordInputText.value,
                                onSuccess = {
                                    showProgressBar.value = false
                                    showSuccessDialog.value = true
                                },
                                onError = {
                                    showProgressBar.value = false
                                    viewModel.showPopUpError.value = true
                                })
                        },
                        text = btnText,
                        modifier = Modifier.padding(top = 30.toScaleDp()),
                        isEnabled = isRegisterEnabled
                    )
                }
                Spacer(modifier = Modifier.weight(1f))
                Box(
                    modifier = Modifier
                        .padding(16.toScaleDp(), top = 48.toScaleDp())
                        .align(Alignment.CenterHorizontally)
                ) {
                    TextWithClickablePart(
                        nonClickableText = stringResource(Res.string.already_have_an_account),
                        clickableText = stringResource(Res.string.sign_in),
                        onClick = { isRegisterSelected.value = false }
                    )
                }
            }
        } else {
            Column(
                modifier = Modifier.fillMaxWidth()
                    .padding(horizontal = 12.dp),
            ) {
                Text(
                    text = title,
                    color = Color.Black,
                    fontSize = 32.toScaleSp(),
                    lineHeight = 38.toScaleSp(),
                    fontWeight = FontWeight.W700,
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Spacer(modifier = Modifier.height(11.toScaleDp()))
                Text(
                    text = description,
                    color = RegisterSubTitle,
                    textAlign = TextAlign.Center,
                    fontSize = 16.toScaleSp(),
                    lineHeight = 20.toScaleSp(),
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Spacer(modifier = Modifier.height(41.toScaleDp()))

                if (viewModel.showForgotPasswordView.value) {
                    ForgotPasswordWebView(
                        onDismiss = {
                            viewModel.showForgotPasswordView.value = false
                            viewModel.emailInput.value = ""
                        },
                        emailInput = viewModel.emailInput,
                        onSendResetLink = {
                            viewModel.forgotPassword()
                        }
                    )
                } else {
                    val emailNotValidText = stringResource(Res.string.email_format_not_valid)
                    Box(modifier = Modifier.height(320.dp)) {
                        PlatformLogin(
                            emailLabel = stringResource(Res.string.email_address),
                            emailPlaceholder = stringResource(Res.string.your_email_address),
                            passwordLabel = stringResource(Res.string.password),
                            passwordPlaceholder = stringResource(Res.string.your_password),
                            forgotPasswordLabel = stringResource(Res.string.forgot_password),
                            loginButtonLabel = stringResource(Res.string.sign_in),
                            onCredentialsEntered = { email, password ->
                                if (!isValidEmail(email)) {
                                    viewModel.errorText.value = emailNotValidText
                                    viewModel.showPopUpError.value = true
                                    return@PlatformLogin
                                }
                                showProgressBar.value = true
                                viewModel.login(
                                    email = email,
                                    password = password,
                                    onSuccess = {
                                        onSuccessfulLogin(
                                            showProgressBar,
                                            workspaceViewModel,
                                            pricingViewModel,
                                            viewModel,
                                            navHostController
                                        )
                                    },
                                    onError = {
                                        showProgressBar.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                            },
                            onPasswordForgotten = { email ->
                                if (isValidEmail(email)) {
                                    viewModel.emailInput.value = email
                                }
                                viewModel.showForgotPasswordView.value = true
                            },
                            visibility = !viewModel.showForgotPasswordView.value,
                            onCreateAccount = {
                                isRegisterSelected.value = true
                            }
                        )
                    }

                    Column {
                        AuthLoginButtons(
                            onRegisteredWithGoogle = { response ->
                                showProgressBar.value = true
                                viewModel.loginWithGoogle(
                                    googleResult = response,
                                    onSuccess = {
                                        onSuccessfulLogin(
                                            showProgressBar,
                                            workspaceViewModel,
                                            pricingViewModel,
                                            viewModel,
                                            navHostController
                                        )
                                        CoroutineScope(Dispatchers.Default).launch {
                                            viewModel.updatePushToken()
                                        }
                                        CoroutineScope(Dispatchers.Default).launch {
                                            viewModel.updatePushToken()
                                        }
                                    },
                                    onError = {
                                        showProgressBar.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                            },
                            onRegisteredWithApple = { response ->
                                showProgressBar.value = true
                                viewModel.loginWithApple(
                                    appleResult = response,
                                    onSuccess = {
                                        onSuccessfulLogin(
                                            showProgressBar,
                                            workspaceViewModel,
                                            pricingViewModel,
                                            viewModel,
                                            navHostController
                                        )
                                        CoroutineScope(Dispatchers.Default).launch {
                                            viewModel.updatePushToken()
                                        }
                                        CoroutineScope(Dispatchers.Default).launch {
                                            viewModel.updatePushToken()
                                        }
                                    },
                                    onError = {
                                        showProgressBar.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                            },
                            onRegisteredWithMicrosoft = { response ->
                                showProgressBar.value = true
                                viewModel.loginWithMicrosoft(
                                    microsoftResult = response,
                                    onSuccess = {
                                        onSuccessfulLogin(
                                            showProgressBar,
                                            workspaceViewModel,
                                            pricingViewModel,
                                            viewModel,
                                            navHostController
                                        )
                                        CoroutineScope(Dispatchers.Default).launch {
                                            viewModel.updatePushToken()
                                        }
                                        CoroutineScope(Dispatchers.Default).launch {
                                            viewModel.updatePushToken()
                                        }
                                    },
                                    onError = {
                                        showProgressBar.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                            }
                        )
                    }
                    Spacer(modifier = Modifier.weight(1f))
                    Box(
                        modifier = Modifier
                            .padding(16.toScaleDp(), top = 48.toScaleDp())
                            .align(Alignment.CenterHorizontally)
                    ) {
                        if (isRegisterSelected.value) {
                            TextWithClickablePart(
                                nonClickableText = stringResource(Res.string.already_have_an_account),
                                clickableText = stringResource(Res.string.sign_in),
                                onClick = { isRegisterSelected.value = false }
                            )
                        } else {
                            TextWithClickablePart(
                                nonClickableText = stringResource(Res.string.need_an_account),
                                clickableText = stringResource(Res.string.create_one),
                                onClick = {
                                    println("click register")
                                    isRegisterSelected.value = true
                                }
                            )
                        }
                    }
                }
            }
        }
    }

}

@Composable
fun TextWithClickablePart(
    nonClickableText: String,
    clickableText: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val annotatedText = buildAnnotatedString {
        withStyle(
            style = SpanStyle(
                color = Color(0xFF797676),
                fontSize = 16.toScaleSp()
            )
        ) {
            append(nonClickableText)
        }
        append(" ")

        pushStringAnnotation(tag = "CLICKABLE", annotation = "clickable")
        withStyle(
            style = SpanStyle(
                color = BlueApp,
                textDecoration = TextDecoration.Underline,
                fontSize = 16.toScaleSp()
            )
        ) {
            append(clickableText)
        }
        pop()
    }

    DisableSelection {
        ClickableText(
            text = annotatedText,
            onClick = { offset ->
                annotatedText.getStringAnnotations(tag = "CLICKABLE", start = offset, end = offset)
                    .firstOrNull()?.let {
                        onClick()
                    }
            },
            modifier = modifier
                .padding(bottom = 16.toScaleDp())
                .pointerHoverIcon(PointerIcon.Hand),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
fun ColumnScope.AuthLoginButtons(
    onRegisteredWithGoogle: (GoogleSignInResult?) -> Unit,
    onRegisteredWithApple: (AppleSignInResult?) -> Unit,
    onRegisteredWithMicrosoft: (MicrosoftSignInResult?) -> Unit,
) {
    Spacer(Modifier.height(10.dp))

    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Divider(modifier = Modifier.weight(2f), thickness = 2.dp)
        Text(
            modifier = Modifier.weight(0.5f),
            textAlign = TextAlign.Center,
            fontSize = 18.sp,
            color = MaterialTheme.colors.onSurface.copy(alpha = 0.12f),
            text = "or"
        )
        Divider(modifier = Modifier.weight(2f), thickness = 2.dp)
    }
    Spacer(Modifier.height(16.dp))

    DisableSelection {
        GoogleButtonContainer(
            modifier = Modifier
                .height(50.dp)
                .fillMaxWidth()
                .align(Alignment.CenterHorizontally)
                .pointerHoverIcon(PointerIcon.Hand),
            text = stringResource(Res.string.continue_with_google),
            mode = GoogleButtonMode.WhiteWithOutline,
            onResult = { result ->
                result.fold(
                    onSuccess = { user ->
                        onRegisteredWithGoogle(user)
                        println("Google Signed in: $user")
                    },
                    onFailure = { error -> println("Google Sign-In failed: ${error.message}") }
                )
            },
        )
    }

    Spacer(Modifier.height(10.dp))

    DisableSelection {
        AppleButtonContainer(
            modifier = Modifier
                .height(50.dp)
                .fillMaxWidth()
                .align(Alignment.CenterHorizontally)
                .pointerHoverIcon(PointerIcon.Hand),
            text = stringResource(Res.string.continue_with_apple),
            mode = AppleButtonMode.WhiteWithOutline,
            onResult = { result ->
                result.fold(
                    onSuccess = { user ->
                        onRegisteredWithApple(user)
                        println("Apple Signed in: $user")
                    },
                    onFailure = { error -> println("Apple Sign-In failed: ${error.message}") }
                )
            },
        )
    }
    Spacer(Modifier.height(10.dp))

    DisableSelection {
        MicrosoftLogin(
            modifier = Modifier
                .height(50.dp)
                .fillMaxWidth()
                .align(Alignment.CenterHorizontally)
                .pointerHoverIcon(PointerIcon.Hand),
            text = stringResource(Res.string.continue_with_microsoft),
            mode = MicrosoftButtonMode.WhiteWithOutline,
            onResult = { result ->
                result.fold(
                    onSuccess = { user ->
                        onRegisteredWithMicrosoft(user)
                        println("Microsoft Signed in: $user")
                    },
                    onFailure = { error -> println("Microsoft Sign-In failed: ${error.message}") }
                )
            }
        )
    }
    Spacer(Modifier.height(10.dp))
}
